<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <non-trend-chart ref="chartInstance"
                         class="widget-contents-chart"
                         :type="opts.chartType"
                         :x-axis="xAxis"
                         :y-axis="yAxis"
                         :tooltip="toolTip"
                         :series-options="seriesOptions"
                         :data="widgetData"
        />
      </div>
    </div>
  </div>
</template>
<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'

  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'

  // 스토어 헬퍼 객체
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetIpsecDisconnTunnel',
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 2,
        opts: {
          chartType: 'bar'
        },
        title: 'widgetIpsecDisconnTunnel',
        isLock: false,
        isMove: true,
        isResize: true,
        eventBus: true,
        deviceType: [20],
        restData: {
          result: [],
          unit_time: ''
        },
        seriesOptions: {
          barWidth: '40%',
          itemStyle: {
            color: 'red'
          }
        },
        widgetData: []
      }
    },
    computed: {
      xAxis () {
        const xAxisOptions = {}
        xAxisOptions.axisLabel = {
          formatter: this.axisFormatter
        }

        return xAxisOptions
      },
      yAxis () {
        const yAxisOptions = {}
        yAxisOptions.axisLabel = {
          formatter: (value) => {
            return value
          }
        }
        return yAxisOptions
      },
      toolTip () {
        return {
          formatter: this.tooltipFormatter
        }
      },
      widgetCustomMenu () {
        return []
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      /*
        이름: axisFormatter
        설명: Axis 포맷을 설정한다.
      */
      axisFormatter (instance) {
        let disconnSec = instance

        const dayValue = Math.floor(disconnSec / 86400)
        disconnSec -= dayValue * 3600 * 24

        const hourValue = Math.floor(disconnSec % 86400 / 3600)
        disconnSec -= hourValue * 3600

        const minValue = Math.floor(disconnSec % 3600 / 60)
        disconnSec -= minValue * 60

        const secValue = Math.floor(disconnSec % 3600 % 60)

        const stringDay = (dayValue === 0) ? '' : String(dayValue) + this.$t('cmn.day')
        const stringHour = (hourValue === 0) ? '' : String(hourValue) + this.$tc('cmn.timeHour', 1)
        const stringMin = (minValue === 0) ? '' : String(minValue) + this.$tc('cmn.timeMinute')
        const stringSec = (secValue === 0) ? '' : String(secValue) + this.$tc('cmn.timeSecond', 1)

        /*
          차트 Y축 라벨 2개의 단위로 간추리기

          1. 일 / 시간, 일 / 분, 일 / 초
          2. 시간 / 분, 시간 / 초
          3. 분 / 초
          4. 초
        */

        // 1. 변환된 시간 중에 "일" 단위가 1일 이상인 경우
        if (stringDay !== '') {
          return `${stringDay} ${(stringHour !== '') ? stringHour : (stringMin !== '') ? stringMin : stringSec}`
        } else if (stringHour !== '') {
          // 2. 변환된 시간 중에 "시간" 단위가 1시간 이상인 경우
          return `${stringHour} ${(stringMin !== '') ? stringMin : stringSec}`
        } else {
          return `${stringMin} ${stringSec}`
        }
      },
      /*
        이름: tooltipFormatter
        설명: Tooltip 포맷을 설정한다.
      */
      tooltipFormatter (instance) {
        let disconnSec = instance[0].data

        const dayValue = Math.floor(disconnSec / 86400)
        disconnSec -= dayValue * 3600 * 24

        const hourValue = Math.floor(disconnSec % 86400 / 3600)
        disconnSec -= hourValue * 3600

        const minValue = Math.floor(disconnSec % 3600 / 60)
        disconnSec -= minValue * 60

        const secValue = Math.floor(disconnSec % 3600 % 60)

        const stringDay = (dayValue === 0) ? '' : String(dayValue) + this.$t('cmn.day')
        const stringHour = (hourValue === 0) ? '' : String(hourValue) + this.$tc('cmn.timeHour', 1)
        const stringMin = (minValue === 0) ? '' : String(minValue) + this.$tc('cmn.timeMinute')
        const stringSec = (secValue === 0) ? '' : String(secValue) + this.$tc('cmn.timeSecond', 1)

        const {name, marker} = _.isArray(instance) ? instance[0] : instance

        return `${marker} ${name} : <b>${stringDay} ${stringHour} ${stringMin} ${stringSec}</b>`
      },
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        const contentsOptions = {
          timeRange: 24, // TAMS 무시 (Top 선택된 기간에 따름)
          widgetType: 'ipsec_vpn_disconnection_status'
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams && extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }

        // API 호출
        const {code, result} = await this.getWidgetData(contentsOptions)

        // Sereis 데이터 구성
        if (code === 'ok') {
          this.restData = result

          const disconnTunnels = []

          for (const tunnel of this.restData.result || []) {
            disconnTunnels.push({
              name: _.escape(String(tunnel.name)), // TAMS
              value: tunnel.value
            })
          }

          this.widgetData = disconnTunnels
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    },
    watch: {}
  }
</script>

<style scoped>
</style>
